<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                name: '',
                html: '',
            }"
            :filters-default="{
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 名前', value: 'name', },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="保存名"
            form-modal-id="listing_html"
            search-action="listing_html/index"
            item-id="id"
            @after-save="onAfterSave"
            >
            <template v-slot:form="{ form, init }">
                <ListingHtml :model="form" :init="init"></ListingHtml>
            </template>

            <template v-slot:column="{ item }">
                <b-col md="6" class="align-self-center">
                    <p class="mb-1">
                        <span v-if="item.is_default">
                            ※初期値
                        </span>
                    </p>

                    <p v-if="item.name">
                        {{ item.name }}
                    </p>
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <div v-if="item.hs_code">
                        HSコード：{{ item.hs_code }}
                    </div>
                    <div v-if="item.country">
                        原産国：{{ item.country }}
                    </div>
                </b-col>
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import ListingHtml from '@/components/ListingHtml.vue'

export default {
    components: {
        GridPage,
        ListingHtml,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        onAfterSave() {
            this.$refs.gridPage.search()
        },
    },
}
</script>

